import { useState, useCallback, useEffect } from 'react';
import { useGenerationControl } from '../../../hooks/useCoupons';
import { useBranches } from '../../../hooks/useBranches';
import { usePlans } from '../../../hooks/usePlans';
import { useGroups } from '../../../hooks/useGroups';
import { usePaymentMethods } from '../../../hooks/usePaymentMethods';
import { transformGenerationControlData, cleanFilters } from '../utils/generationControlUtils';

export const useGenerationControlTable = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    branch: '',
    plan: '',
    group: '',
    payment_method: '',
    quarter: '',
    year: new Date().getFullYear(),
    contract_number: '',
  });
  const [hasSearched, setHasSearched] = useState(false);

  const { data: branches } = useBranches();
  const { data: plans } = usePlans();
  const { data: groups } = useGroups();
  const { data: paymentMethods } = usePaymentMethods();

  const {
    data: generationControlResponse,
    isLoading,
    refetch,
  } = useGenerationControl(cleanFilters(filter), { enabled: hasSearched });

  useEffect(() => {
    if (generationControlResponse?.results) {
      const transformedData = transformGenerationControlData(generationControlResponse.results);
      setData(transformedData);
    }
  }, [generationControlResponse]);

  const handleFilter = useCallback((event) => {
    const { name, value } = event.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleSearch = useCallback(() => {
    setHasSearched(true);
    refetch();
  }, [refetch]);

  const initializeDefaultValues = useCallback(() => {
    if (branches && branches.length > 0 && !filter.branch) {
      setFilter((prev) => ({
        ...prev,
        branch: branches[0].uuid,
      }));
    }

    if (plans && plans.length > 0 && !filter.plan) {
      setFilter((prev) => ({
        ...prev,
        plan: plans[0].uuid,
      }));
    }
  }, [branches, plans, filter.branch, filter.plan]);

  return {
    data,
    isLoading,
    filter,
    branches: branches || [],
    plans: plans || [],
    groups: groups || [],
    paymentMethods: paymentMethods || [],
    handleFilter,
    handleSearch,
    initializeDefaultValues,
  };
};
